<template>
  <div class="cloud-node-create">
    <template v-if="firstStep">
      <b-form-group :label="$t('communication.form.channelType')">
        <multiselect
          id="multiselectChannelType"
          v-model="form.channel"
          :options="channelList"
          :allowEmpty="false"
          :show-labels="false"
          :searchable="false"
          :placeholder="$t('communication.form.channelType')"
          :limit="3"
          :show-no-results="false"
          :state="validateState('channel')"
        />
      </b-form-group>

      <Input
        label="communication.form.webhookUrl"
        id="webhook_url"
        v-model="form.webhook_url"
        :state="validateState('webhook_url')"
      />
    </template>
    <template v-else>
      <InfoBox>
        {{ $t('communication.form.codeInfo') }}
      </InfoBox>
      <NumberInput
        label="communication.form.passcode"
        placeholder="communication.form.passcode"
        id="passcode"
        v-model="validateForm.passcode"
        :state="validateFormState('passcode')"
      />
    </template>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateCommunicationChannels',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      firstStep: true,
      form: {
        webhook_url: '',
        channel: '',
      },
      validateForm: {
        passcode: '',
      },
      channelList: ['mattermost', 'telegram'],
    }
  },
  validations: {
    form: {
      webhook_url: {
        required,
      },
      channel: {
        required,
      },
    },
    validateForm: {
      passcode: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    validateFormState(name) {
      const { $dirty, $error } = this.$v.validateForm[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }
      let params = {
        webhook_url: this.form.webhook_url,
      }

      ApiService.post(`communicator/${this.form.channel}`, params)
        .then(({ data }) => {
          this.$emit('resetDetailForm', false)
          this.firstStep = false
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
          this.$v.$reset()
        })
    },
    confirmSecondStep() {
      this.$v.validateForm.$touch()
      if (this.$v.validateForm.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }
      let params = {
        passcode: this.validateForm.passcode,
      }

      ApiService.post(`communicator/${this.form.channel}/verify`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
          this.firstStep = true
          this.$v.$reset()
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
          this.$v.$reset()
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        if (this.firstStep) this.confirm()
        else this.confirmSecondStep()
      }
    },
  },
}
</script>
